// extracted by mini-css-extract-plugin
module.exports = {"photo":"FeedPhotosItem_photo__13kX_","visualizacao":"FeedPhotosItem_visualizacao__1ZAIA"};